import AreasScreen from "./areas";
import OnGoingTripsScreen from "./onGoingTrips";
import PerformanceScreen from "./performance";
import RoutesScreen from "./routes";
import RoutesCreateScreen from "./RoutesCreate";
import RoutesUpdateScreen from "./RoutesUpdate";
import TripsScreen from "./trips";
import TripsDriverScreen from "./tripsDriver";
import TripsListRouteScreen from "./tripsListRoute";
import TripsSchedule from "./tripsSchedule";
import NotificationsScreen from "./Notifications";
import RouteView from "./RouteView";
import ChatMessages from "./chatMessages";
import CurrencyVehicleLocationScreen from "./currencyVehicleLocation";
import CheckpointsScreen from "./checkpoints";
import RoutesTripUpdate from "./RoutesTripUpdate";
import PerformanceScreenList from "./performanceScreenList";
import TripSmartRoute from "./tripSmartRoute";
import PointsScreen from "./pointsScreen";
import InterestPointsScreen from "./interestPointsScreen";
import InterestPointsCreateScreen from "./interestPointsScreen/Create";
import InterestPointsEditScreen from "./interestPointsScreen/Edit";
import TripsVehicleScreen from "./tripsVehicle";
import PackagesScreen from "./package";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  AreasScreen,
  OnGoingTripsScreen,
  PerformanceScreen,
  PerformanceScreenList,
  RoutesScreen,
  PackagesScreen,
  TripsScreen,
  RoutesCreateScreen,
  RoutesUpdateScreen,
  TripsListRouteScreen,
  TripsDriverScreen,
  TripsSchedule,
  NotificationsScreen,
  RouteView,
  ChatMessages,
  CurrencyVehicleLocationScreen,
  CheckpointsScreen,
  RoutesTripUpdate,
  TripSmartRoute,
  PointsScreen,
  InterestPointsScreen,
  InterestPointsCreateScreen,
  InterestPointsEditScreen,
  TripsVehicleScreen,
};
